import {useEffect, useMemo, useState} from "react";
import {NavLink, useParams} from "react-router-dom";
import Data from "../../Data";
import Error from "./Error";

const ExperienceBundles = () => {
    const { id } = useParams();

    const [experience, setExperience] = useState(null);
    const [bundles, setBundles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    const load = async () => {
        setLoading(true);
        try {
            const exp = await Data.fetchExperienceById({ id });
            setExperience(exp.data);
            const result = await Data.fetchBundlesForExperience({ experienceId: id });
            setBundles(result.data);
        } catch(e){
            setError(true);
        } finally { setLoading(false); }
    }

    useEffect(() => { load(); }, []);

    const futureEvents = useMemo(() => experience?.futureEvents || [], [experience]);

    const remove = async (bundleId) => {
        try {
            if(window.confirm('Are you sure you want to delete this bundle?')){
                await Data.deleteBundle({ id: bundleId });
                await load();
            }
        } catch(err){
            setError(true);
        }
    }

    return (
        <div className={"bg-white w-full rounded-lg border drop-shadow-sm"}>
            <div className={"my-2 flex justify-between items-center py-4 px-6"}>
                <p className={"text-lg"}>Bundles</p>
                <NavLink to={`/admin/experiences/${id}/bundles/create`} className={"bg-backgroundGrey border flex items-center gap-1 px-2.5 py-1.5 rounded-md hover:opacity-80 transition"}>Create Bundle</NavLink>
            </div>

            {error ? <Error message={"There was a problem loading or saving bundles."} /> : null}

            <div className={"grid grid-cols-1 border-t"}>
                        {bundles.length ? bundles.map(b => (
                            <div key={b._id} className={"flex justify-between items-center border-b p-6"}>
                                <div className={"grid grid-cols-1"}>
                                    <p className={"font-semibold"}>{b.name}</p>
                                    <p className={"text-textGrey"}>£{b.price} per person • {b.events.length} events</p>
                                </div>
                                <div className={"flex gap-2 flex-wrap"}>
                                    <NavLink to={`/admin/experiences/${id}/bundles/${b._id}`} className={"bg-backgroundGrey border px-2.5 py-1.5 rounded-md hover:opacity-80 transition"}>View</NavLink>
                                    <button onClick={() => remove(b._id)} className={"bg-red-200 text-red-900 border-0 px-2.5 py-1.5 rounded-md hover:opacity-80 transition"}>Delete</button>
                                </div>
                            </div>
                        )) : <div className={"p-6 text-textGrey"}>No bundles created yet.</div>}
            </div>
        </div>
    )
}

export default ExperienceBundles


